import { createSelector } from 'reselect';

import getMenu from './getMenu';

const getMenuSection = createSelector(
  getMenu,
  (s, sectionId) => sectionId,
  (menu, sectionId) => {
    if (menu && sectionId) {
      const section = menu.sections.find(
        x => x.id.toString() === sectionId.toString(),
      );
      return section || null;
    }

    return null;
  },
);

export const getSection = createSelector(
  getMenuSection,
  // TODO: move this
  state => state.getIn(['conversion', 'sectionDetails', 'search']),
  (section, search) => {
    if (section) {
      let products = Object.values(section.products);
      if (search) products = search.get('data').toJS();

      return { ...section, products };
    }

    return null;
  },
);

export const getTotalItems = createSelector(
  getMenuSection,
  // TODO: move this
  state => state.getIn(['conversion', 'sectionDetails', 'search']),
  (section, search) => {
    if (!search && section) return section.totalProducts;
    if (section) return search.total;

    return null;
  },
);
